import React from 'react';
import PropTypes from 'prop-types';
import LinkButton from '../Models/LinkButton/LinkButton';
import Button from '../Button/Button';
import css from './DidntFindAnswer.module.scss';

const DidntFindAnswer = ({
    lang,
    formLink
}) => {
    return formLink ? (
        <div className={css.block} >
            <div className={css.text}>{lang.didntFindAnswerText}</div>
            <div className={css['link-container']}>
                <Button className={css.link} secondary href={formLink.url} target={formLink.target}>{formLink.text}</Button>
            </div>
        </div>
    ) : null;
};

DidntFindAnswer.propTypes = {
    lang: PropTypes.shape({
        didntFindAnswerText: PropTypes.string.isRequired,
    }).isRequired,
    formLink: PropTypes.shape(LinkButton.propTypes)
};

export default DidntFindAnswer;



// WEBPACK FOOTER //
// ./src/components/DidntFindAnswer/DidntFindAnswer.jsx